// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-evaluation-label{font-size:14px;font-weight:600;color:#475569;margin:0 0 4px 0;display:flex;align-items:center;gap:4px}", ""]);
// Exports
module.exports = exports;
